var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModal",
        { attrs: { titulo: "Tramo" }, on: { cerrar: _vm.handleCerrar } },
        [
          _c("div", {
            staticStyle: {
              "letter-spacing": "0.02em",
              "white-space": "nowrap",
              overflow: "hidden",
              "text-overflow": "ellipsis",
              "margin-top": "16px"
            }
          }),
          _c(
            "div",
            { staticClass: "boton_crear" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "icon",
                  staticStyle: {
                    "background-color": "rgb(255, 108, 0)",
                    "border-color": "rgb(255, 108, 0)",
                    "padding-right": "20px",
                    display: "block",
                    margin: "0 0 0 auto",
                    "margin-top": "13px",
                    height: "38px"
                  },
                  on: { click: _vm.crear }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "color-blanco",
                      staticStyle: { color: "white" }
                    },
                    [_vm._v("Guardar")]
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _c("ContenidoModal", [
        _c(
          "div",
          { attrs: { align: "center" } },
          [
            _c(
              "v-flex",
              { attrs: { md10: "" } },
              [
                _c(
                  "v-card",
                  { staticClass: "rounded-card" },
                  [
                    _c(
                      "v-form",
                      {
                        ref: "form",
                        staticClass: "col-md-12",
                        attrs: { "lazy-validation": "" }
                      },
                      [
                        _c(
                          "v-container",
                          {
                            staticStyle: { padding: "30px 40px 50px 40px" },
                            attrs: { "grid-list-md": "" }
                          },
                          [
                            _c(
                              "FormFieldsContainer",
                              { attrs: { titulo: "Alta de Técnico" } },
                              [
                                _vm._t("prependInformacionGeneral"),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: _vm.formFields.id.label,
                                        disabled: ""
                                      },
                                      model: {
                                        value: _vm.formFields.id.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.id,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.id.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label:
                                          _vm.formFields.nombre_tramo.label,
                                        type: "text",
                                        required: ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.nombre_tramo.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.nombre_tramo,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.nombre_tramo.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-autocomplete", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      attrs: {
                                        label: _vm.formFields.tipo_tramo.label,
                                        items: _vm.tramoslist,
                                        "data-vv-name": "tipos de tramo",
                                        "item-text": "configvalor",
                                        "item-value": "configid",
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.formFields.tipo_tramo.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.tipo_tramo,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.tipo_tramo.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isEdit,
                                        expression: "isEdit"
                                      }
                                    ],
                                    attrs: { xs4: "", sm4: "", md4: "" }
                                  },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        label: _vm.formFields.activo.label,
                                        items: _vm.formFields.activo.items,
                                        "item-text": "label",
                                        "item-value": "id",
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.formFields.activo.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.activo,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.activo.value"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }